import React, { useState } from 'react';

import Box from '@tds/core-box';
import Form from './components/form';
import Success from './components/success';

const LogDefect = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  return (
    <div className="container 85%">
      <div id="introduction">
        <div id="introduction-wrapper">
          <Box tag="section" inset={4} between={3}>
            {!formSubmitted && <Form setFormSubmitted={setFormSubmitted} />}
            {formSubmitted && <Success />}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default LogDefect;
